import { post } from 'epics/ajax';
import { Observable } from 'epics/rxjs';
import { contextPath } from 'util/history';
import type { CreateCommentResponse } from './types';

export const createComment = (
    issueId: number,
    comment: string,
    fileIds: string[],
    xsrfToken: string,
    context: string = contextPath
): Observable<CreateCommentResponse> => {
    const uri = `${context}/rest/servicedesk/1/servicedesk/customer/comment`;
    const body = {
        issueId,
        comment,
        fileIds,
        xsrfToken,
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };

    return post(uri, body, headers)
        .map((ajaxResponse) => ajaxResponse.response)
        .catch((e) => {
            return Observable.throw(e);
        });
};
